import { Box, useTheme } from '@mui/material';
import { useContext } from 'react';

import { Spinner } from '@/components/common/Spinner';
import { UsersContext } from '@/Contexts/UsersContext';
import { UserType } from '@/models/User';
import Applicant_MyAccount from './Applicant_MyAccount/Applicant_MyAccount';
import { ADF_MyAccount } from './ADF_MyAccount/ADF_MyAccount';
import { InternationalPartner_MyAccount } from './InternationalPartner_MyAccount/InternationalPartner_MyAccount';
import { RegionalCoordinator_MyAccount } from './RegionalCoordinator_MyAccount/RegionalCoordinator_MyAccount';
import { StateCoordinator_MyAccount } from './StateCoordinator_MyAccount/StateCoordinator_MyAccount';

const views = (userType: UserType | null): React.ComponentType => {
  switch (userType) {
    case UserType.StateCoordinator:
      return StateCoordinator_MyAccount;
    case UserType.RegionalCoordinator:
      return RegionalCoordinator_MyAccount;
    case UserType.NationalProgrammeLead:
      return InternationalPartner_MyAccount;
    case UserType.Adf:
      return ADF_MyAccount;
    case UserType.Applicant:
      return Applicant_MyAccount;
    default:
      return () => <Spinner />;
  }
};

function MyAccount() {
  const theme = useTheme();

  const { userType } = useContext(UsersContext);

  const CurrentView = views(userType);

  return (
    <Box sx={{ overflowX: 'hidden' }} display='flex' flex={1} justifyContent='center'>
      <Box
        color={theme.palette.taiga.main}
        display='flex'
        flexDirection='column'
        flexGrow={1}
        gap='10px'
        minWidth='500px'
        maxWidth='1080px'
        margin='40px 0px'
      >
        <Box display='flex' flexDirection='column'>
          <CurrentView />
        </Box>
      </Box>
    </Box>
  );
}

export default MyAccount;
